import "./style.scss";
const WrapperError = ({ text }) => {
  return (
    <div className="wrapperError">
      <p>{text}</p>
    </div>
  );
};

export default WrapperError;
